(function() { module.exports = window["wp"]["keycodes"]; }());